import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_SUB_ACCOUNT = (permissions: string[]) => gql`
  query fetchSubAccount($id: ObjectID!) {
    fetchSubAccount(subAccountId: $id) {
      subAccount {
        id
        name
        state
        liquidated
        createdAt
        tradingProcess
        calculatedSuitabilityScore
        account {
          id
          type
          user {
            id
            ${permissions.includes('read:client_low_risk_pii') ? 'firstName' : ''}
            ${permissions.includes('read:client_low_risk_pii') ? 'middleName' : ''}
            ${permissions.includes('read:client_low_risk_pii') ? 'lastName' : ''}
            organization {
              id
            }
            statistics {
              marketValueCents
            }
            subAccounts {
              id
              account {
                type
              }
              goal {
                name
              }
              financialProduct {
                translatedName { ${TRANSLATED_STRING_FIELDS} }
              }
            }
          }
        }
        goal {
          id
          name
          financialProduct {
            id
            translatedName { ${TRANSLATED_STRING_FIELDS} }
            theme {
              id
              translatedName { ${TRANSLATED_STRING_FIELDS} }
            }
          }
        }
        skipIPS
        allowClientDeposits
        isPartial
        theme {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
        financialProduct {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
          riskReturnLevel
        }
        suggestedFinancialProduct {
          id
        }
        ${permissions.includes('read:billing_schedule') ? 'applicableBillingSchedule { id frequency }' : ''}
        ${permissions.includes('read:fee_tier') ? 'applicableFeeTier { id name }' : ''}
        ${permissions.includes('read:fee_tier') ? 'feeTier { id name }' : ''}
        ${permissions.includes('read:billing_schedule') ? 'billingSchedule { id frequency }' : ''}
        statistics {
          marketValueCents
          simpleReturnAmount
          simpleReturnPercent
        }
      }
    }
  }
`;

export const TRANSITION_SUB_ACCOUNT = gql`
  mutation transitionSubAccount($input: TransitionSubAccountInput!) {
    transitionSubAccount(input: $input) {
      subAccount {
        id
      }
    }
  }
`;

export const CLOSE_SUB_ACCOUNT = gql`
  mutation closeSubAccount($input: CloseSubAccountInput!) {
    closeSubAccount(input: $input) {
      subAccount {
        id
      }
    }
  }
`;
